<template>
  <div>
    <div class="scrole">
      <el-input placeholder="请输入内容" v-model="input3">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-button type="primary" icon="el-icon-edit" style="margin-left:30px" @click="addClick">新增</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="date" label="型号"></el-table-column>
      <el-table-column prop="name" label="型号名称"></el-table-column>
      <el-table-column prop="address" label="要素个数"></el-table-column>
      <el-table-column prop="address" label="默认别名"></el-table-column>
      <el-table-column prop="address" label="上下线范围"></el-table-column>
      <el-table-column prop="address" label="填入时间"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100">
        <template slot-scope="{row}">
          <el-button size="mini" type="danger" @click="deleData(row)"  icon="el-icon-delete" round>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <PageHelper :page-data="pageData"></PageHelper>

    <!-- 添加要素 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleAdd" width="30%" :close-on-click-modal="false">
      <add :diohide='diohide' />
       <span slot="footer" class="dialog-footer addcentent">
    </span>
    </el-dialog>
    


  </div>
</template>
<script>
import PageHelper from "@/components/common/PageHelper";
// import add from "./components/add";
export default {
  components: {
    PageHelper,
  },
  data() {
    return {
      dialogVisibleAdd:false,
      dialogVisible:true,
      pageData: {
        page: 1,
        rows: 10,
        total: 10
      },
      input3: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ]
    };
  },
  methods: {
      //新增
      addClick(){
          this.dialogVisibleAdd = true
      },
    // 修改
    editFrom() {
         this.dialogVisibleAdd = true
    },
    // 关闭子组件的方法
    diohide(){
        this.dialogVisibleAdd = false
    },
    //删除
    deleData() {
         this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
           closeOnClickModal:false,
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    }
  }
};
</script>
<style>
.scrole {
  width: 40%;
  padding: 20px;
  display: flex;
}
.scrole input {
  /* width:40%; */
  padding: 20px !important ;
}
</style>

